import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { languageFromPath } from "@/lib/languageFromPath";

/**
 * El idioma lo manda la URL (/:lang/slug): en cada navegación, también atrás/adelante.
 * Es un layout effect para que la página no llegue a pintarse en el idioma anterior.
 */
export function useLanguageFromUrl() {
  const { pathname } = useLocation();
  const { language, setLanguage } = useLanguage();
  const idiomaDeLaUrl = languageFromPath(pathname);

  useLayoutEffect(() => {
    if (language !== idiomaDeLaUrl) setLanguage(idiomaDeLaUrl);
  }, [language, idiomaDeLaUrl, setLanguage]);
}
